import { IbaseWidgetDetails } from "@/lib/widgetsLayoutDir";
import { Button } from "@/components/UI/Button";

export interface IDisplayAndSVG {
  displayName: string;
  icon: JSX.Element;
}

const ToolTipMappedSVGandButton = ({
  button,
  onClickAction,
  dataTestID,
}: {
  button: IbaseWidgetDetails | IDisplayAndSVG;
  onClickAction: Function;
  dataTestID: string;
}) => {
  const idForDiv = button.displayName.toString().replace(/\s+/g, "");

  return (
    <Button
      variant="hoverMenu"
      size={"icon_tooltip"}
      onClick={() => {
        onClickAction(button);
      }}
      data-testid={dataTestID}
      className={`${button.displayName == "Clear" ? "hover:bg-red-500 dark:hover:bg-red-500" : ""} flex justify-start`}
    >
      <div
        className="flex h-4 w-4 items-center justify-center"
        id={idForDiv + "Icon"}
      >
        {button.icon}
      </div>
      <div className="" id={idForDiv}>
        {button.displayName}
      </div>
    </Button>
  );
};

export default ToolTipMappedSVGandButton;
